import React, { createContext, useContext, useMemo } from "react";
import { ConversationDriverImpl } from "./ConversationDriver";
import { useDaoContext } from "fe-web-components/diseaseview/DaoContext";

export const driverContextObject = createContext<ConversationDriverImpl>(null);

export const ConversationDriverProvider = ({ children = null }) => {
  const ContextProvider = driverContextObject.Provider;
  const dao = useDaoContext();

  const driver = useMemo(() => new ConversationDriverImpl(dao), [dao]);

  return <ContextProvider value={driver}>{children}</ContextProvider>;
};

export const useConversationDriver = () => useContext(driverContextObject);
